import "../scss/style.scss";
import $ from 'jquery';
import "magnific-popup";
import "./lib/ofi.min.js";

// smooth scroll
$(function() {
	$('a[href^="#"]').not('.js-popup').click(function(){
		var speed = 1000;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});
});

$(function ($) {
	var mvh = $('.js-mv').height();

	$(window).scroll(function() {
		var top = $(window).scrollTop();
		if (mvh < top) {
			$('.js-fixed').addClass('is-on');
			} else {
				$('.js-fixed').removeClass('is-on');
			}
	});
});

// SP nav
$(document).ready(function () {
	$('.js-nav-bt').on('click', function () {
		if ($('.js-nav-content').hasClass('close')) {
			$(".js-nav-content").removeClass('close');
			$(this).removeClass('close');
		} else {
			$(".js-nav-content").addClass('close');
			$(this).addClass('close');
		}
	});
	$('.js-nav-bt.close, .js-nav-link').on('click', function () {
		$(".js-nav-content, .js-nav-bt.close").removeClass('close');
		$(".js-nav-content, .js-nav-bt.close").removeClass('close');
	});
});

jQuery(function ($) {
	$('.js-popup').magnificPopup({
		type:'inline',
	});
});

$(function () {
	if (window.matchMedia('(max-width: 768px)').matches) {
		$('.topSolution-reviewList-item.is-sp').on('click', function (event) {
			event.preventDefault();
			$(this).toggleClass('sp-pull-on');
		});
	}
});

jQuery(function($) {
  if ( $('.error')[0] ) {
    $('.mw_wp_form').addClass('mw_wp_form_error');
  }
});
